import axios from "axios";
import { useEffect, useState } from "react";

interface IGetAutocompleteRequest {
    dictionaryName: string,
    parentDictionaryId?: string,
}

export interface IDictionaryItem {
    DictionaryType: string
    Id: string
    Name: string
    NamePl: string
    NameEn: string
    Description: string
    Visualization: string

    Config: string
    BaseUrl?: string
}

type GetAutocompleteApi = [(m: IGetAutocompleteRequest) => void, IDictionaryItem[], boolean, boolean];
export const useGetDictionaryApi: () => GetAutocompleteApi = () => {
    const [model, setModel] = useState<IGetAutocompleteRequest>(null);
    const [result, setResult] = useState<IDictionaryItem[]>(null);

    const [isLoading, setIsLoading] = useState(false);
    const [isError, setIsError] = useState(false);

    useEffect(() => {
        const fetchData = async () => {
            setIsError(false);
            setIsLoading(true);
            setResult(null);
            try {
                const result = await axios.get('/Dictionaries/GetAutocomplete/', {
                    params: {
                        maxRows: 9000,
                        dictionaryName: model.dictionaryName,
                        parentDictionaryId: model.parentDictionaryId,
                    }
                });
                setResult(result.data);
            } catch (error) {
                console.error(error);
                setIsError(true);
            }
            setIsLoading(false);
        };

        if (!model)
            return;

        fetchData();
    }, [model]);

    return [setModel, result, isLoading, isError];
}